// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IRecordErrorDto
 */
export interface IRecordErrorDto {
    /**
     * 
     * @type {string}
     * @memberof IRecordErrorDto
     */
    type?: IRecordErrorDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IRecordErrorDto
     */
    field_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRecordErrorDto
     */
    error_details?: string;
    /**
     * 
     * @type {string}
     * @memberof IRecordErrorDto
     */
    error_code?: string;
    /**
     * 
     * @type {Date}
     * @memberof IRecordErrorDto
     */
    created_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IRecordErrorDtoTypeEnum {
    VALIDATION_ERROR = 'VALIDATION_ERROR',
    PROCESSING_ERROR = 'PROCESSING_ERROR'
}


/**
 * Check if a given object implements the IRecordErrorDto interface.
 */
export function instanceOfIRecordErrorDto(value: object): value is IRecordErrorDto {
    return true;
}

export function IRecordErrorDtoFromJSON(json: any): IRecordErrorDto {
    return IRecordErrorDtoFromJSONTyped(json, false);
}

export function IRecordErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRecordErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'field_name': json['field_name'] == null ? undefined : json['field_name'],
        'error_details': json['error_details'] == null ? undefined : json['error_details'],
        'error_code': json['error_code'] == null ? undefined : json['error_code'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function IRecordErrorDtoToJSON(json: any): IRecordErrorDto {
    return IRecordErrorDtoToJSONTyped(json, false);
}

export function IRecordErrorDtoToJSONTyped(value?: IRecordErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'field_name': value['field_name'],
        'error_details': value['error_details'],
        'error_code': value['error_code'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

